export const PersonIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="24" viewBox="0 0 18 24">
        <g id="Gegegvens-icon" transform="translate(-3)">
            <circle id="Ellipse_6" data-name="Ellipse 6" cx="6" cy="6" r="6" transform="translate(6)"/>
            <path id="Path_6" data-name="Path 6" d="M12,14a9.01,9.01,0,0,0-9,9,1,1,0,0,0,1,1H20a1,1,0,0,0,1-1A9.01,9.01,0,0,0,12,14Z"/>
        </g>
    </svg>
)